import { render, staticRenderFns } from "./Publishers.vue?vue&type=template&id=b8a432e2&scoped=true"
import script from "./Publishers.vue?vue&type=script&lang=js"
export * from "./Publishers.vue?vue&type=script&lang=js"
import style0 from "./Publishers.vue?vue&type=style&index=0&id=b8a432e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a432e2",
  null
  
)

export default component.exports